class StoreDetail extends Component {

    /**
     * @param {HTMLDivElement} el
     * @property {HTMLDivElement} summary
     * @property {HTMLAnchorElement} buttonFull
     */
    constructor(el) {
        super(el);

        this.summary = this.$find('#summary');
        this.buttonFull = this.$find('#buttonFull');

        this.checkSummaryHeight();
        this.addEventListeners();
    }

    checkSummaryHeight() {
        if (this.summary && this.summary.clientHeight > 130) {
            this.summary.classList.add('showLess');
        } else {
            this.buttonFull.style.display = 'none';
        }
    }

    activateFullDescription() {
        this.summary.classList.remove('showLess');
        this.buttonFull.style.display = 'none';
    }

    addEventListeners() {
        this.buttonFull.addEventListener('click', (e) => {
            e.preventDefault();
            this.activateFullDescription();
        });
    }
}
